// extracted by mini-css-extract-plugin
module.exports = {"container":"container--dvvvL","left-button":"left-button--GPF2Q","leftButton":"left-button--GPF2Q","right-button":"right-button--31SMu","rightButton":"right-button--31SMu"};